import { IUserPermissionPresenterSchema } from '../../repositories/monolith-python/entities/presenters/UserPermissionPresenterSchema';
import { IUserPhoneSchema } from '../../repositories/monolith-python/entities/user/UserPhoneSchema';

export interface IUser {
  /** Тип агента **/
  accountType?: string;
  /** Тип агента **/
  agentAccountType?: string;
  /** Ссылка на аватар пользователя/агента **/
  avatarUrl?: string;
  /** Баланс пользователя **/
  balance?: number;
  /** Может ли пользователь опубликовывать объявления и вакансии **/
  canPublishOffer: boolean;
  /** md5 от емайла пользователя, если он фейковый отдаем None **/
  criteoEmail?: string;
  /** Имя пользователя/агента **/
  displayName?: string;
  /** Емайл пользователя, если он фейковый отдаем None **/
  email?: string;
  /** Имя **/
  firstName?: string;
  /** Cian ID пользователя **/
  id?: number;
  /** Агент ли пользователь **/
  isAgent?: boolean;
  /** Авторизован ли пользователь **/
  isAuthenticated: boolean;
  /** Является ли пользователь застройщиком **/
  isBuilder?: boolean;
  /** Партнер ЦИАН **/
  isCianPartner?: boolean;
  /** Модератор ли пользователь **/
  isModerator?: boolean;
  /** Новый ли пользователь **/
  isNew?: boolean;
  /** Профи ли пользователь **/
  isProfi?: boolean;
  /** Есть ли подписки у пользователя **/
  isSubscriptions?: boolean;
  /** Контрольная сумма пользователя для чата webim КпН (Консультантов по Новостройкам) **/
  kpnWebimChecksum?: string;
  /** Фамилия **/
  lastName?: string;
  /** Права пользователя **/
  permissions?: IUserPermissionPresenterSchema;
  /** Телефоны **/
  phones?: IUserPhoneSchema[];
  /** Имеет ли пользователь публичный профиль **/
  publicProfile: boolean;
  /** Пакеты пользователя **/
  tariff?: string[];
  /** Realty ID пользователя **/
  userId?: number;
  /** Уровень доверия **/
  userTrustLevel?: EUserTrustLevel;
  /** Тип пользователя **/
  userType?: string;
}

export enum EUserTrustLevel {
  /** Очень много жалоб **/
  Danger = 'danger',
  /** Исключен из программы **/
  Excluded = 'excluded',
  /** участвует **/
  Involved = 'involved',
  /** Новый пользователь **/
  New = 'new',
  /** не участвует **/
  NotInvolved = 'notInvolved',
}

export interface IUsersResponse {
  statusCode: 200;
  headers: [string, string][];
  response: {
    user: IUser;
  };
}
